import React from 'react';
import './Notification.css';

const Notification = ({ message, type, onClose }) => {
    return (
        <div className={`alertmessage ${type}`}>
            <p className='alertmessagetxt'>{message}</p>
            <button className='alertmessageclose' onClick={onClose}></button>
        </div>
    );
};

export default Notification;